import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"

import { BackButton } from "../BackButton"

import style from "./styles.module.scss"
import { TEXTS } from "./constants"

import { createPath } from "modules/ClientAccount/utils"
import { Button, Headline3, Img } from "ui-kit/components-branded"
import { chatSelector } from "utils/store/selectors/chat"
import { ROLES } from "utils/constants"

export function NoChat() {
    const { role } = useSelector(chatSelector)
    const isPsy = role === ROLES.PSY
    const navigate = useNavigate()

    function onClick() {
        const path = isPsy ? "/psychologist-account/clients" : createPath("/sessions")
        navigate(path)
    }

    return (
        <div className={style.container}>
            <div className={style.header} onClick={() => window.history.back()}>
                <BackButton />
            </div>
            <div className={style.content}>
                <Img src="talk.svg" className={style.img} />
                {isPsy ? (
                    <>
                        <Headline3 className={style.text}>{TEXTS.PSY}</Headline3>
                        <Button color="primary" className={style.button} onClick={onClick}>
                            Посмотреть клиентов
                        </Button>
                    </>
                ) : (
                    <>
                        <Headline3 className={style.text}>{TEXTS.CLIENT}</Headline3>
                        <Button color="primary" className={style.button} onClick={onClick}>
                            Посмотреть мои сессии
                        </Button>
                    </>
                )}
            </div>
        </div>
    )
}
